import styled from 'styled-components'

export const StyledContainer = styled.div`
    margin: 0 auto;
    padding: 5.6rem 1rem;
    max-width: 120.7rem;
`
export const StyledMainContent = styled.div`
    margin-top: 7.3rem;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .login-input {
        width: 44.7rem;
    }

    @media( max-width: 1114px ) {
        justify-content: center;

        .welcome-image {
            display: none;
        }
    }
    @media( max-width: 500px ) {
        .login-input {
            width: 100%;
        }
    }
`

export const StyledForm = styled.form`
    .welcome-text {
        font-weight: 700;
        font-size: 4rem;
        letter-spacing: -0.04em;
        color: ${({ theme }) => theme.colors?.darkBlue};
    }

    .sub-text {
        margin: 1rem 0 3.6rem 0;
        font-size: 2rem;
        color: ${({ theme }) => theme.colors?.grey};
    }

    .forgot-password-text {
        margin-top: 2.4rem;
        font-weight: 600;
        font-size: 1.2rem;
        letter-spacing: 0.1em;
        text-transform: uppercase;
        color: ${({ theme }) => theme.colors?.green};
    }
`